export const normalizeFormConfigName = (name) => name.split(' ').join('').toLowerCase();